
import { POST } from "../API";
let source = null;

export const updateUserProfilePicturesApi = (data, onSuccess, onError) => {
    source = POST(`/api/v1/identity/users/set_profile_picture`, data, onSuccess, onError, true, source);
};
